import {compose} from 'redux';
import find from 'lodash/find';
import findIndex from 'lodash/findIndex';
import PropTypes from 'prop-types';
import {getWindow} from 'ssr-window';
import EnvironmentUtils from '@spothero/utils/environment';
import SearchTracking from 'utils/search-tracking';
import SpotMap from './SpotMap';
import withConfig from 'config/withConfig';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {GOOGLE_MAPS_LAT_LNG} from '../search-prop-types';
import {push} from 'router/router-actions';
import {resetFilters} from 'filters/filters-actions';
import {updateSelected} from 'spot/spot-actions';
import {panMap, setSearchMapInstance, setZoom} from 'search/search-actions';
import {notify} from 'notification/notification-actions';

const window = getWindow();
const isBrowser = EnvironmentUtils.isBrowser();
const gmaps = isBrowser ? window.google.maps : null;

class SearchAirportMap extends Component {
    static propTypes = {
        isMobile: PropTypes.bool.isRequired,
        searchRequestId: PropTypes.string,
        destination: PropTypes.shape({
            title: PropTypes.string.isRequired,
            latitude: PropTypes.number.isRequired,
            longitude: PropTypes.number.isRequired,
            position: GOOGLE_MAPS_LAT_LNG,
        }).isRequired,
        ends: PropTypes.string,
        idealDistance: PropTypes.number,
        isFiltered: PropTypes.bool,
        kmlMapLayerEnabled: PropTypes.bool,
        kmlMapLayerURL: PropTypes.string,
        mapLoadingIncrement: PropTypes.number,
        onPan: PropTypes.func,
        onZoom: PropTypes.func,
        overrideIdealZoom: PropTypes.bool,
        pushTo: PropTypes.func,
        requestIncrements: PropTypes.number,
        resetFiltersClick: PropTypes.func,
        searchString: PropTypes.string,
        latitude: PropTypes.number,
        longitude: PropTypes.number,
        selectedSpot: PropTypes.object,
        setSearchMap: PropTypes.func,
        updateSelectedSpot: PropTypes.func,
        onMarkerClick: PropTypes.func.isRequired,
        spots: PropTypes.arrayOf(PropTypes.object),
        starts: PropTypes.string,
        staticBaseUrl: PropTypes.string.isRequired,
        zoom: PropTypes.number,
        sendNotification: PropTypes.func.isRequired,
    };

    _onMarkerClick = spotId => {
        const {
            spots,
            starts,
            ends,
            pushTo,
            updateSelectedSpot,
            onMarkerClick,
        } = this.props;
        const spot = find(spots, {spotId});
        const {facility: {spot_details_url: spotDetailsUrl = ''} = {}} = spot;

        updateSelectedSpot({
            spot,
            referrer: 'pin',
        });

        onMarkerClick(findIndex(spots, {spotId}) + 1);

        pushTo(
            `/${spotDetailsUrl}/?airport=true&starts=${starts}&ends=${ends}`
        );
    };

    _onMapMoved = ({zoomed = false, autoZoomed = false}) => {
        SearchTracking.updateAction(
            zoomed ? (autoZoomed ? 'AUTO_ZOOM' : 'ZOOM') : 'PAN'
        );
    };

    render() {
        const {
            isMobile,
            searchRequestId,
            spots,
            zoom,
            onPan,
            onZoom,
            isFiltered,
            destination,
            searchString,
            latitude,
            longitude,
            starts,
            ends,
            idealDistance,
            overrideIdealZoom,
            mapLoadingIncrement,
            requestIncrements,
            resetFiltersClick,
            kmlMapLayerURL,
            kmlMapLayerEnabled,
            selectedSpot,
            setSearchMap,
            staticBaseUrl,
            sendNotification,
        } = this.props;

        return (
            <div className="SearchMap">
                <SpotMap
                    ref={node => {
                        this._spotMap = node;
                    }}
                    isMobile={isMobile}
                    searchRequestId={searchRequestId}
                    isFiltered={isFiltered}
                    zoom={zoom}
                    onPan={onPan}
                    onZoom={onZoom}
                    idealDistance={idealDistance}
                    overrideIdealZoom={overrideIdealZoom}
                    destination={destination}
                    spots={spots}
                    searchType="airport"
                    searchString={searchString}
                    latitude={latitude}
                    longitude={longitude}
                    starts={starts}
                    ends={ends}
                    setSearchMap={setSearchMap}
                    mapLoadingIncrement={mapLoadingIncrement}
                    requestIncrements={requestIncrements}
                    onMarkerClick={this._onMarkerClick}
                    resetFiltersClick={resetFiltersClick}
                    kmlMapLayerURL={kmlMapLayerURL}
                    kmlMapLayerEnabled={kmlMapLayerEnabled}
                    selectedSpot={selectedSpot}
                    onMapMoved={this._onMapMoved}
                    staticBaseUrl={staticBaseUrl}
                    sendNotification={sendNotification}
                />
            </div>
        );
    }
}

const mapStateToProps = state => {
    const {
        search: {
            data: {
                currentIncrement,
                requestIncrements,
                zoom,
                overrideIdealZoom,
                destinationTitle,
                selectedSpot,
                kmlMapLayerEnabled,
                kmlMapLayerURL,
            },
        },
        searchRequest: {
            id,
            starts,
            ends,
            latitude,
            longitude,
            search_string: searchString,
            ideal_search_distance: idealDistance,
        },
        filters: {numActive},
    } = state;

    return {
        latitude,
        longitude,
        destination: {
            title: destinationTitle,
            latitude,
            longitude,
            position: isBrowser ? new gmaps.LatLng(latitude, longitude) : null,
        },
        ends,
        idealDistance,
        isFiltered: numActive > 0,
        kmlMapLayerEnabled,
        kmlMapLayerURL,
        mapLoadingIncrement: currentIncrement,
        overrideIdealZoom,
        requestIncrements,
        searchRequestId: id,
        searchString,
        selectedSpot,
        starts,
        zoom,
    };
};

const mapDispatchToProps = {
    onPan: panMap,
    onZoom: setZoom,
    resetFiltersClick: resetFilters,
    setSearchMap: setSearchMapInstance,
    updateSelectedSpot: updateSelected,
    pushTo: push,
    sendNotification: notify,
};

const enhance = compose(
    withConfig(['isMobile', 'staticBaseUrl']),
    connect(mapStateToProps, mapDispatchToProps)
);

export default enhance(SearchAirportMap);
